angular.module('omfm').directive('wkCheckColumn', WkCheckColumnDirective);

WkCheckColumnDirective.$inject = ['$rootScope'];

function WkCheckColumnDirective($rootScope) {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {
			col: "=",
			type: "@"
		},
		templateUrl: "/app/omfm/templates/wkCheckColumn.html",
		link:        function ($scope) {
			$scope.toggleSelect = function(forceSelected) {
				$scope.col.selected = typeof forceSelected == "undefined" ? !$scope.col.selected : !!forceSelected;

				$rootScope.$broadcast('wk:colSelected', {
					col:  $scope.col,
					type: $scope.type
				});
			};

			$scope.$on('wk:massSelect', function(event, data){
				if(data.type !== $scope.type) {
					return;
				}

				$scope.toggleSelect(data.selected);
			});

			$scope.isSelected = function(){
				return $scope.col.selected;
			};
		}
	}
}